import type { CompanyTagType as ApiCompanyTagType } from 'src/api/generated/touring/types';

import { CompanyTagType } from './types';

export const mapCompanyTagType = (apiTag: ApiCompanyTagType): CompanyTagType => {
  return {
    value: apiTag.value,
    label: apiTag.label,
  };
};
